(function() {
  'use strict';

  var ROOT_SELECTOR = '[data-ml-sold-out-guard]';
  var ACTION_SELECTOR = [
    '[data-ml-add-to-cart]',
    'button[name="add"]',
    'input[name="add"]',
    '.shopify-payment-button__button',
    'shopify-accelerated-checkout'
  ].join(', ');

  var PERSONALIZER_SELECTOR = [
    '[data-ml-zepto-slot]',
    '.product-personalizer',
    '.pplr-c-button',
    '.ptc_button',
    'button[onclick*="cstmfy_personalize_text"]'
  ].join(', ');

  var NATIVE_ADD_TO_CART_SELECTOR = '[data-ml-add-to-cart]';

  var ZEPTO_ACTION_SELECTOR = [
    '.product-personalizer .pplr-c-button',
    '.product-personalizer .ptc_button',
    '.product-personalizer button[onclick*="cstmfy_personalize_text"]'
  ].join(', ');
  var EXTERNAL_ZEPTO_BLOCK_ATTRIBUTE = 'data-ml-sold-out-guard-blocked';
  var EXTERNAL_ZEPTO_BLOCK_SELECTOR = '[' + EXTERNAL_ZEPTO_BLOCK_ATTRIBUTE + '="true"]';

  var PERSONALIZER_STATUS_DELAY = 5000;
  var PERSONALIZER_WATCH_INTERVAL = 500;
  var PERSONALIZER_WATCH_LIMIT = 60000;

  var PRODUCT_FORM_SELECTOR = [
    'form.product-form',
    'form[action*="/cart/add"]',
    'form[action*="/cart"]'
  ].join(', ');

  function getVariantString(key, fallback) {
    return window.variantStrings && window.variantStrings[key] ? window.variantStrings[key] : fallback;
  }

  function isAddToCartAction(el) {
    return !!(el && ((el.hasAttribute && el.hasAttribute('data-ml-add-to-cart')) || el.getAttribute('name') === 'add'));
  }

  function getActionLabelNode(el) {
    if (!el || !el.querySelector) return el;
    return el.querySelector('span:not(.svg-wrapper):not(.loading__spinner)') || el;
  }

  function setActionLabel(el, text) {
    if (!el || !text) return;

    if (el.tagName && el.tagName.toLowerCase() === 'input') {
      if (el.value !== text) el.value = text;
    } else {
      var labelNode = getActionLabelNode(el);
      if (String(labelNode.textContent || '').replace(/\s+/g, ' ').trim() !== text) {
        labelNode.textContent = text;
      }
    }

    if (el.getAttribute('aria-label') !== text) el.setAttribute('aria-label', text);
  }

  function requestFrame(callback) {
    return (window.requestAnimationFrame || function(cb) { return window.setTimeout(cb, 0); })(callback);
  }

  function closest(el, selector) {
    if (!el || !selector) return null;
    if (el.closest) return el.closest(selector);

    var node = el;
    while (node && node.nodeType === 1) {
      if (node.matches && node.matches(selector)) return node;
      node = node.parentNode;
    }

    return null;
  }

  function parseBoolean(value) {
    if (value === true || value === 'true') return true;
    if (value === false || value === 'false') return false;
    return null;
  }

  function getProductData(root) {
    if (!root) return null;
    if (root._mlSoldOutProductData) return root._mlSoldOutProductData;

    var dataScript = root.querySelector('script[id^="ProductData-"]');
    if (!dataScript) return null;

    try {
      root._mlSoldOutProductData = JSON.parse(dataScript.textContent || '{}');
      return root._mlSoldOutProductData;
    } catch (error) {
      root._mlSoldOutProductData = null;
      return null;
    }
  }

  function getCommerceStateData(root) {
    if (!root) return null;
    if (root._mlCommerceStateData) return root._mlCommerceStateData;

    var dataScript = root.querySelector('script[id^="AICommerceState-"]');
    if (!dataScript) return null;

    try {
      root._mlCommerceStateData = JSON.parse(dataScript.textContent || '{}');
      return root._mlCommerceStateData;
    } catch (error) {
      root._mlCommerceStateData = null;
      return null;
    }
  }

  function getVariantAvailability(variant) {
    if (!variant || typeof variant.available === 'undefined') return null;
    return parseBoolean(variant.available);
  }

  function variantIsUnavailable(variant) {
    return getVariantAvailability(variant) === false;
  }

  function variantAllowsBackorder(variant) {
    return !!(variant &&
      variant.inventory_management === 'shopify' &&
      Number(variant.inventory_quantity || 0) <= 0 &&
      variant.inventory_policy === 'continue');
  }

  function normalizeCommerceState(value, variant) {
    var availability = getVariantAvailability(variant);
    if (availability === false) return 'OutOfStock';

    var normalized = String(value || '').toLowerCase().replace(/[\s_-]+/g, '');

    if (normalized === 'preorder' || normalized === 'preordered' || normalized === 'presale') return 'PreOrder';
    if (normalized === 'backorder' || normalized === 'backordered') return 'BackOrder';

    if (availability === true) {
      if (variantAllowsBackorder(variant)) return 'BackOrder';
      return 'InStock';
    }

    if (normalized === 'instock' || normalized === 'available') return 'InStock';
    if (normalized === 'outofstock' || normalized === 'soldout' || normalized === 'unavailable') return 'OutOfStock';

    return 'InStock';
  }

  function getSelectedCommerceState(root, variant) {
    var commerceData = getCommerceStateData(root);
    var selectedId = variant && variant.id != null ? String(variant.id) : getSelectedVariantId(root);

    if (commerceData && commerceData.variants && selectedId && commerceData.variants[selectedId]) {
      return normalizeCommerceState(commerceData.variants[selectedId].state, variant);
    }

    if (commerceData && commerceData.initial_state) {
      return normalizeCommerceState(commerceData.initial_state, variant);
    }

    return normalizeCommerceState(root ? root.getAttribute('data-ai-commerce-state') : '', variant);
  }

  function getSchemaAvailability(state) {
    return 'https://schema.org/' + normalizeCommerceState(state);
  }

  function setCommerceStateAttributes(root, state, variant) {
    if (!root) return;

    var normalizedState = normalizeCommerceState(state, variant);
    root.setAttribute('data-ai-commerce-state', normalizedState);
    root.setAttribute('data-ai-schema-availability', getSchemaAvailability(normalizedState));

    if (variant && variant.id != null) {
      root.setAttribute('data-ai-selected-variant-id', String(variant.id));
    }
  }

  function getCommerceActionLabel(state) {
    if (state === 'PreOrder') return 'Pre-order';
    if (state === 'BackOrder') return 'Backorder';
    return getVariantString('addToCart', 'Add to cart');
  }

  function getSelectedVariantId(root) {
    if (!root) return '';

    var variantField = root.querySelector('[data-ml-variant-select]') ||
      root.querySelector('select[id^="VariantId-"]') ||
      root.querySelector('form.product-form select[name="id"]') ||
      root.querySelector('form.product-form input[name="id"]') ||
      root.querySelector('[name="id"][form^="products-one-form-"]');

    return variantField && variantField.value != null ? String(variantField.value) : '';
  }

  function getSelectedVariant(root) {
    var data = getProductData(root);
    if (!data || !data.variants || !data.variants.length) return null;

    var selectedId = getSelectedVariantId(root);
    if (selectedId) {
      for (var i = 0; i < data.variants.length; i += 1) {
        var variant = data.variants[i];
        if (variant && String(variant.id) === selectedId) return variant;
      }
    }

    if (data.selected_or_first_available_variant) return data.selected_or_first_available_variant;
    return data.variants[0] || null;
  }

  function selectedVariantIsSoldOut(root, variant) {
    variant = variant || getSelectedVariant(root);

    var availability = getVariantAvailability(variant);
    if (availability !== null) return availability === false;

    var commerceState = getSelectedCommerceState(root, variant);
    if (commerceState === 'OutOfStock') return true;

    var initialVariantAvailable = parseBoolean(root.getAttribute('data-ml-initial-variant-available'));
    if (initialVariantAvailable !== null) return !initialVariantAvailable;

    var productAvailable = parseBoolean(root.getAttribute('data-ml-product-available'));
    if (productAvailable !== null) return !productAvailable;

    return false;
  }

  function ensureBackInStockMessage(root) {
    if (!root) return null;

    var message = root.querySelector('[data-ml-sold-out-message]');
    if (message) return message;

    var template = root.querySelector('[data-ml-sold-out-message-template]');
    if (!template || !template.content) return null;

    var fragment = template.content.cloneNode(true);
    message = fragment.querySelector('[data-ml-sold-out-message]');
    if (!message) return null;

    template.parentNode.insertBefore(fragment, template);
    return message;
  }

  function updateBackInStockForms(root, variant) {
    if (!root) return;

    var forms = root.querySelectorAll('[data-ml-sold-out-message] form');
    if (!forms.length) return;

    var variantId = variant && variant.id != null ? String(variant.id) : getSelectedVariantId(root);
    var variantTag = variantId ? 'variant_' + variantId : '';

    for (var i = 0; i < forms.length; i += 1) {
      var tagsInput = forms[i].querySelector('[data-ml-back-in-stock-tags]');
      if (!tagsInput) continue;

      var baseTags = tagsInput.getAttribute('data-ml-base-tags') || '';
      var nextTags = baseTags;
      if (variantTag) nextTags = nextTags ? nextTags + ', ' + variantTag : variantTag;
      tagsInput.value = nextTags;
    }
  }

  function rememberAttr(el, name, key) {
    if (!el || !el.dataset || typeof el.dataset[key] !== 'undefined') return;
    el.dataset[key] = el.hasAttribute(name) ? el.getAttribute(name) || '' : '__ml_absent__';
  }

  function restoreAttr(el, name, key) {
    if (!el || !el.dataset || typeof el.dataset[key] === 'undefined') return;

    var value = el.dataset[key];
    if (value === '__ml_absent__') el.removeAttribute(name);
    else el.setAttribute(name, value);

    delete el.dataset[key];
  }

  function disableAction(el) {
    if (!el || !el.dataset) return;

    if (el.dataset.mlSoldOutGuardDisabled !== 'true') {
      el.dataset.mlSoldOutGuardDisabled = 'true';
      el.dataset.mlSoldOutWasDisabled = el.disabled ? 'true' : 'false';
      rememberAttr(el, 'aria-disabled', 'mlSoldOutOriginalAriaDisabled');
      rememberAttr(el, 'tabindex', 'mlSoldOutOriginalTabindex');

      if (isAddToCartAction(el)) {
        rememberAttr(el, 'hidden', 'mlSoldOutOriginalHidden');
      }
    }

    if (isAddToCartAction(el)) {
      if (el.hidden) el.hidden = false;
      if (el.hasAttribute('hidden')) el.removeAttribute('hidden');
      setActionLabel(el, getVariantString('soldOut', 'Out of stock'));
    }

    if (typeof el.disabled !== 'undefined' && el.disabled !== true) el.disabled = true;
    if (el.getAttribute('aria-disabled') !== 'true') el.setAttribute('aria-disabled', 'true');
    if (el.getAttribute('tabindex') !== '-1') el.setAttribute('tabindex', '-1');
  }

  function restoreAction(el, commerceState) {
    if (!el || !el.dataset) return;

    var isAddAction = isAddToCartAction(el);

    if (el.dataset.mlSoldOutGuardDisabled !== 'true') {
      if (isAddAction) setActionLabel(el, getCommerceActionLabel(commerceState));
      return;
    }

    var wasDisabled = el.dataset.mlSoldOutWasDisabled === 'true';

    if (typeof el.disabled !== 'undefined') {
      el.disabled = isAddAction ? false : wasDisabled;
    }

    if (isAddAction) {
      setActionLabel(el, getCommerceActionLabel(commerceState));
      restoreAttr(el, 'hidden', 'mlSoldOutOriginalHidden');
    }

    restoreAttr(el, 'aria-disabled', 'mlSoldOutOriginalAriaDisabled');
    restoreAttr(el, 'tabindex', 'mlSoldOutOriginalTabindex');

    delete el.dataset.mlSoldOutGuardDisabled;
    delete el.dataset.mlSoldOutWasDisabled;
  }

  function setPersonalizerAccessibility(el, soldOut) {
    if (!el || !el.dataset) return;

    if (soldOut) {
      rememberAttr(el, 'aria-hidden', 'mlSoldOutOriginalAriaHidden');
      if (el.getAttribute('aria-hidden') !== 'true') el.setAttribute('aria-hidden', 'true');
      return;
    }

    restoreAttr(el, 'aria-hidden', 'mlSoldOutOriginalAriaHidden');
  }

  function toggleMessages(root, soldOut) {
    if (soldOut) ensureBackInStockMessage(root);
    var messages = root.querySelectorAll('[data-ml-sold-out-message]');
    for (var i = 0; i < messages.length; i += 1) {
      if (soldOut) {
        if (messages[i].hidden) messages[i].hidden = false;
        if (messages[i].hasAttribute('hidden')) messages[i].removeAttribute('hidden');
      } else {
        if (!messages[i].hidden) messages[i].hidden = true;
        if (!messages[i].hasAttribute('hidden')) messages[i].setAttribute('hidden', 'hidden');
      }
    }
  }

  function toggleActions(root, soldOut, commerceState) {
    var actions = root.querySelectorAll(ACTION_SELECTOR);
    for (var i = 0; i < actions.length; i += 1) {
      if (soldOut) disableAction(actions[i]);
      else restoreAction(actions[i], commerceState);
    }

    var personalizers = root.querySelectorAll(PERSONALIZER_SELECTOR);
    for (var j = 0; j < personalizers.length; j += 1) {
      setPersonalizerAccessibility(personalizers[j], soldOut);
    }
  }

  function applySoldOutState(root) {
    if (!root) return;

    var variant = getSelectedVariant(root);
    var commerceState = getSelectedCommerceState(root, variant);
    var soldOut = selectedVariantIsSoldOut(root, variant);

    if (soldOut) commerceState = 'OutOfStock';
    setCommerceStateAttributes(root, commerceState, variant);
    root.classList.toggle('ml-product-is-sold-out', soldOut);
    root.setAttribute('data-ml-sold-out-active', soldOut ? 'true' : 'false');

    if (soldOut) ensureBackInStockMessage(root);
    updateBackInStockForms(root, variant);
    toggleMessages(root, soldOut);
    toggleActions(root, soldOut, commerceState);
    syncPurchaseActions(root);
  }

  function isSoldOutActive(root) {
    return !!(root && (root.getAttribute('data-ml-sold-out-active') === 'true' || root.classList.contains('ml-product-is-sold-out')));
  }

  function isZeptoActionable(action) {
    if (!action || action.hidden || action.disabled) return false;
    if (typeof action.isConnected !== 'undefined' && !action.isConnected) return false;
    if (action.getAttribute('aria-disabled') === 'true') return false;
    if (closest(action, '[hidden], [aria-hidden="true"]')) return false;

    var styles = window.getComputedStyle ? window.getComputedStyle(action) : null;
    if (styles && (styles.display === 'none' || styles.visibility === 'hidden' || styles.pointerEvents === 'none')) {
      return false;
    }

    if (!(action.offsetWidth || action.offsetHeight || (action.getClientRects && action.getClientRects().length))) {
      return false;
    }

    return typeof window.cstmfy_personalize_text === 'function' ||
      /cstmfy_personalize_text/.test(action.getAttribute('onclick') || '');
  }

  function findZeptoAction(root) {
    if (!root) return null;
    return root.querySelector(ZEPTO_ACTION_SELECTOR) || document.querySelector(ZEPTO_ACTION_SELECTOR);
  }

  function trackExternalZeptoElement(root, element) {
    if (!root || !element) return;
    if (!root._mlExternalZeptoElements) root._mlExternalZeptoElements = [];
    if (root._mlExternalZeptoElements.indexOf(element) === -1) {
      root._mlExternalZeptoElements.push(element);
    }
  }

  function blockExternalZeptoElement(root, element) {
    if (!root || !element || root.contains(element)) return;

    trackExternalZeptoElement(root, element);
    element.setAttribute(EXTERNAL_ZEPTO_BLOCK_ATTRIBUTE, 'true');
  }

  function restoreExternalZeptoElements(root) {
    if (!root || !root._mlExternalZeptoElements) return;

    for (var i = 0; i < root._mlExternalZeptoElements.length; i += 1) {
      var element = root._mlExternalZeptoElements[i];
      if (!element) continue;

      if (element.getAttribute(EXTERNAL_ZEPTO_BLOCK_ATTRIBUTE) === 'true') {
        element.removeAttribute(EXTERNAL_ZEPTO_BLOCK_ATTRIBUTE);
      }
    }

    root._mlExternalZeptoElements = [];
  }

  function syncExternalZeptoSoldOutState(root, soldOut) {
    if (!root) return;

    if (!soldOut) {
      restoreExternalZeptoElements(root);
      return;
    }

    var actions = document.querySelectorAll(ZEPTO_ACTION_SELECTOR);
    for (var i = 0; i < actions.length; i += 1) {
      var action = actions[i];
      if (!action || root.contains(action)) continue;

      blockExternalZeptoElement(root, action);
      var personalizer = closest(action, '.product-personalizer');
      if (personalizer && !root.contains(personalizer)) {
        blockExternalZeptoElement(root, personalizer);
      }
    }
  }

  function ensurePersonalizerStatus(root) {
    if (!root) return null;

    var existing = root.querySelector('[data-ml-personalizer-status]');
    if (existing) return existing;

    var status = document.createElement('div');
    status.className = 'ml-personalizer-status';
    status.setAttribute('data-ml-personalizer-status', '');
    status.hidden = true;

    var message = document.createElement('p');
    message.className = 'ml-personalizer-status__message';
    message.setAttribute('data-ml-personalizer-status-message', '');
    message.setAttribute('role', 'status');
    message.setAttribute('aria-live', 'polite');
    message.setAttribute('aria-atomic', 'true');
    status.appendChild(message);

    var retry = document.createElement('button');
    retry.type = 'button';
    retry.className = 'button button--secondary ml-personalizer-status__retry';
    retry.setAttribute('data-ml-personalizer-retry', '');
    retry.textContent = 'Retry customizer';
    retry.addEventListener('click', function() {
      root.setAttribute('data-ml-personalizer-state', 'loading');
      message.textContent = 'Retrying the customizer…';
      retry.disabled = true;
      root.dispatchEvent(new CustomEvent('ml:personalizer-retry', { bubbles: true }));
      window.setTimeout(function() {
        window.location.reload();
      }, 250);
    });
    status.appendChild(retry);

    var nativeAction = root.querySelector(NATIVE_ADD_TO_CART_SELECTOR);
    var zeptoSlot = root.querySelector('[data-ml-zepto-slot]');
    var host = (zeptoSlot && zeptoSlot.parentNode) ||
      (nativeAction && nativeAction.parentNode) ||
      root.querySelector('.product-form__buttons') ||
      root;
    var anchor = zeptoSlot || nativeAction;

    if (anchor && anchor.parentNode === host) host.insertBefore(status, anchor.nextSibling);
    else host.appendChild(status);

    return status;
  }

  function hidePersonalizerStatus(root) {
    var status = root && root.querySelector('[data-ml-personalizer-status]');
    if (status && !status.hidden) status.hidden = true;
  }

  function showPersonalizerStatus(root) {
    var status = ensurePersonalizerStatus(root);
    if (!status) return;

    var message = status.querySelector('[data-ml-personalizer-status-message]');
    var retry = status.querySelector('[data-ml-personalizer-retry]');
    if (message) message.textContent = 'The customizer is taking longer than expected to load. Please retry before adding this item.';
    if (retry) retry.disabled = false;
    if (status.hidden) status.hidden = false;
  }

  function clearPersonalizerStatusTimer(root) {
    if (!root || root._mlPersonalizerStatusTimer == null) return;
    window.clearTimeout(root._mlPersonalizerStatusTimer);
    root._mlPersonalizerStatusTimer = null;
  }

  function clearPersonalizerWatch(root) {
    if (!root) return;
    if (root._mlPersonalizerWatchTimer != null) {
      window.clearInterval(root._mlPersonalizerWatchTimer);
      root._mlPersonalizerWatchTimer = null;
    }
    if (root._mlPersonalizerWatchLimitTimer != null) {
      window.clearTimeout(root._mlPersonalizerWatchLimitTimer);
      root._mlPersonalizerWatchLimitTimer = null;
    }
  }

  function startPersonalizerWatch(root) {
    if (!root || root._mlPersonalizerWatchTimer != null) return;

    root._mlPersonalizerWatchTimer = window.setInterval(function() {
      syncPurchaseActions(root);
    }, PERSONALIZER_WATCH_INTERVAL);

    root._mlPersonalizerWatchLimitTimer = window.setTimeout(function() {
      clearPersonalizerWatch(root);
    }, PERSONALIZER_WATCH_LIMIT);
  }

  function schedulePersonalizerStatus(root) {
    if (!root || root._mlPersonalizerStatusTimer != null) return;

    root._mlPersonalizerStatusTimer = window.setTimeout(function() {
      root._mlPersonalizerStatusTimer = null;

      if (isSoldOutActive(root) || root.getAttribute('data-ml-customization-status') !== 'custom') return;
      if (isZeptoActionable(findZeptoAction(root))) {
        syncPurchaseActions(root);
        return;
      }

      root.setAttribute('data-ml-personalizer-state', 'error');
      showPersonalizerStatus(root);
    }, PERSONALIZER_STATUS_DELAY);
  }

  function syncPurchaseActions(root) {
    if (!root) return;

    var soldOut = isSoldOutActive(root);
    var customizationStatus = root.getAttribute('data-ml-customization-status') || 'unknown';
    syncExternalZeptoSoldOutState(root, soldOut);
    var zeptoAction = findZeptoAction(root);
    var useZepto = customizationStatus === 'custom' && !soldOut && isZeptoActionable(zeptoAction);

    if (useZepto) {
      if (!root.classList.contains('ml-has-zepto')) root.classList.add('ml-has-zepto');
      root.setAttribute('data-ml-personalizer-state', 'ready');
      clearPersonalizerStatusTimer(root);
      clearPersonalizerWatch(root);
      hidePersonalizerStatus(root);
      return;
    }

    if (root.classList.contains('ml-has-zepto')) root.classList.remove('ml-has-zepto');

    if (soldOut) {
      root.setAttribute('data-ml-personalizer-state', 'sold-out');
      clearPersonalizerStatusTimer(root);
      clearPersonalizerWatch(root);
      hidePersonalizerStatus(root);
      return;
    }

    if (customizationStatus === 'custom') {
      if (root.getAttribute('data-ml-personalizer-state') !== 'error') {
        root.setAttribute('data-ml-personalizer-state', 'loading');
        schedulePersonalizerStatus(root);
      }
      startPersonalizerWatch(root);
      return;
    }

    root.setAttribute('data-ml-personalizer-state', 'not-applicable');
    clearPersonalizerStatusTimer(root);
    clearPersonalizerWatch(root);
    hidePersonalizerStatus(root);
  }

  function preventSoldOutInteraction(root, event) {
    if (!isSoldOutActive(root)) return;

    var target = event.target;
    var action = event.type === 'submit'
      ? closest(target, PRODUCT_FORM_SELECTOR)
      : closest(target, ACTION_SELECTOR);

    if (!action) return;

    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();

    applySoldOutState(root);

    var message = root.querySelector('[data-ml-sold-out-message]');
    if (message && typeof message.scrollIntoView === 'function' && event.type === 'submit') {
      try {
        message.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } catch (error) {
        message.scrollIntoView();
      }
    }
  }

  function getEventElement(event) {
    var target = event && event.target;
    if (!target) return null;
    return target.nodeType === 1 ? target : target.parentElement;
  }

  function getExternalZeptoInteraction(root, event) {
    var target = getEventElement(event);
    if (!root || !target) return null;

    var blockedElement = closest(target, EXTERNAL_ZEPTO_BLOCK_SELECTOR);
    if (blockedElement && !root.contains(blockedElement)) return blockedElement;

    var action = closest(target, ZEPTO_ACTION_SELECTOR);
    if (!action || root.contains(action)) return null;

    blockExternalZeptoElement(root, action);
    var personalizer = closest(action, '.product-personalizer');
    if (personalizer && !root.contains(personalizer)) {
      blockExternalZeptoElement(root, personalizer);
    }

    return action;
  }

  function preventExternalZeptoInteraction(root, event) {
    if (!root || (typeof root.isConnected !== 'undefined' && !root.isConnected)) return;
    if (!isSoldOutActive(root) || !getExternalZeptoInteraction(root, event)) return;

    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();

    syncExternalZeptoSoldOutState(root, true);

    var message = root.querySelector('[data-ml-sold-out-message]');
    if (message && typeof message.scrollIntoView === 'function') {
      try {
        message.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } catch (error) {
        message.scrollIntoView();
      }
    }
  }

  function nodeContainsZeptoAction(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.matches && node.matches(ZEPTO_ACTION_SELECTOR)) return true;
    return !!(node.querySelector && node.querySelector(ZEPTO_ACTION_SELECTOR));
  }

  function initRoot(root) {
    if (!root || root.dataset.mlSoldOutGuardReady === 'true') return;
    root.dataset.mlSoldOutGuardReady = 'true';

    var scheduled = false;
    function scheduleApply() {
      if (scheduled) return;
      scheduled = true;
      requestFrame(function() {
        scheduled = false;
        applySoldOutState(root);
      });
    }

    root.addEventListener('change', function(event) {
      var target = event.target;
      if (!target) return;
      if (target.matches && target.matches('[name="id"], [data-ml-variant-select]')) scheduleApply();
    }, true);

    root.addEventListener('submit', function(event) {
      preventSoldOutInteraction(root, event);
    }, true);

    root.addEventListener('click', function(event) {
      preventSoldOutInteraction(root, event);
    }, true);

    root.addEventListener('keydown', function(event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      preventSoldOutInteraction(root, event);
    }, true);

    document.addEventListener('click', function(event) {
      preventExternalZeptoInteraction(root, event);
    }, true);

    document.addEventListener('keydown', function(event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      preventExternalZeptoInteraction(root, event);
    }, true);

    document.addEventListener('submit', function(event) {
      preventExternalZeptoInteraction(root, event);
    }, true);

    if (window.MutationObserver) {
      var observer = new MutationObserver(function(records) {
        for (var i = 0; i < records.length; i += 1) {
          var record = records[i];
          if (record.type === 'childList' || record.type === 'attributes') {
            scheduleApply();
            break;
          }
        }
      });

      observer.observe(root, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style', 'disabled', 'aria-disabled', 'hidden']
      });

      var externalObserver = new MutationObserver(function(records) {
        if (typeof root.isConnected !== 'undefined' && !root.isConnected) {
          restoreExternalZeptoElements(root);
          externalObserver.disconnect();
          return;
        }
        if (!isSoldOutActive(root)) return;

        for (var i = 0; i < records.length; i += 1) {
          var addedNodes = records[i].addedNodes || [];
          for (var j = 0; j < addedNodes.length; j += 1) {
            if (nodeContainsZeptoAction(addedNodes[j])) {
              scheduleApply();
              return;
            }
          }
        }
      });

      externalObserver.observe(document.documentElement, {
        childList: true,
        subtree: true
      });
    }

    applySoldOutState(root);
  }

  function init() {
    var roots = document.querySelectorAll(ROOT_SELECTOR);
    for (var i = 0; i < roots.length; i += 1) {
      initRoot(roots[i]);
    }
  }

  window.MLProductPurchaseGuard = window.MLProductPurchaseGuard || {};
  window.MLProductPurchaseGuard.syncRoot = syncPurchaseActions;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
